// extracted by mini-css-extract-plugin
export default {"container":"LE-z","dimension":"ME-z","dimensionLabels":"NE-z"};